import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAnonymousActionTypes {
  Set = 'NEW_ANSWER/ANONYMOUS/SET',
}

type TSetAnonymousTypes = ITypedReduxAction<EAnonymousActionTypes.Set, boolean>;

/**
 * Redux action, который записывает в store анонимный статус пользователя
 * @param name boolean
 */
export const setIsAnonymous: (value: boolean) => TSetAnonymousTypes = actionGenerator<
  EAnonymousActionTypes.Set,
  boolean
>(EAnonymousActionTypes.Set);

export type TAnswerAnonymous = TSetAnonymousTypes;
